import * as React from "react";

type Props = {
  activeTab: "details" | "map";
  onTabChange: (tab: "details" | "map") => void;
};

export function EstimateTabBar(props: Props) {
  return (
    <div className="d-flex d-sm-none border-bottom border-primary border-2">
      <button
        className={`btn flex-fill rounded-0 py-2 ${
          props.activeTab === "details" ? "btn-light" : "btn border-0 text-white-50"
        }`}
        onClick={() => props.onTabChange("details")}
      >
        Details
      </button>
      <button
        className={`btn flex-fill rounded-0 py-2 ${
          props.activeTab === "map" ? "btn-light" : "btn border-0 text-white-50"
        }`}
        onClick={() => props.onTabChange("map")}
      >
        Map
      </button>
    </div>
  );
}
